<template>
    <button :type="type" class="btn" :disabled="loading || disabled">
        <div v-if="loading" class="absolute inset-0 flex items-center justify-center">
            <svg class="animate-spin h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10"></circle>
                <path class="opacity-75" d="M2,12C2,6.481 6.481,2 12,2"></path>
            </svg>
        </div>
        <span :class="{ invisible: loading }"><slot></slot></span>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'button'
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
    }
}
</script>
